import React from 'react';
import {Typography} from '@mui/material';
import {ScrollableModal} from '../Common/ScrollableModal';
import {SaltusAny} from '../../utils/SaltusAny';

interface ActionModalProps {
  title: string;
  isOpen: boolean;
  close?: (event: SaltusAny, reason: 'backdropClick' | 'escapeKeyDown') => void;
  children: React.ReactNode;
  wide?: boolean;
  autoHeight?: boolean;
}

function ActionModal({
  title,
  isOpen,
  close,
  children,
  wide,
  autoHeight,
}: ActionModalProps) {
  return (
    <ScrollableModal
      size={wide ? 'large' : 'small'}
      open={isOpen}
      onClose={close}
      autoHeight={autoHeight}
    >
      <>
        <Typography>
          <strong>{title}</strong>
        </Typography>
        {children}
      </>
    </ScrollableModal>
  );
}

export default ActionModal;
